import { FDWResultEntry } from "../../../restfd2/fdw_result";
import { useStore } from "../state/state";
import Checkbox from "./checkbox";

export function FundingsListItem(props:{entry:FDWResultEntry}){
    const include_in_print = useStore((state) => state.include_in_print);
    const set_include_in_print = useStore((state) => state.set_include_in_print);
    //const setIncludeInPrintExclusive = useQuestionizerStore((state) => state.setIncludeInPrintExclusive);

    const questionizer_open_print_view = useStore((state) => state.questionizer_open_print_view);

    console.log(props.entry);
    
    return (<div className="result-item">
        <Checkbox value={include_in_print[props.entry.fp_id] ?? false} onChange={(value)=>{set_include_in_print(props.entry.fp_id, value)}}/>
        <div className="result-item__body">
          <span className="result-item__name">{props.entry.fp_name}</span>
          <span className="result-item__betrag">{props.entry.fp_betrag}</span>
        </div>
        <span tabIndex={0} aria-label="Als PDF-Dokument anzeigen" className={"result-item__print"} 
          onClick={(_)=>{
            questionizer_open_print_view(props.entry.fp_id);
          }}
          onKeyUp={(event)=>{
            if(event.code != "Enter" && event.code != " "){return;}
            questionizer_open_print_view(props.entry.fp_id);
          }}
          >
            <span aria-hidden className="result-item__print_label">Anzeigen</span><div className={"icon icon-print result-item__icon_print"}></div></span>
    </div>);  
  }

